import type { CostSummaryResource } from '@studio/shared';
import type { ReactNode } from 'react';
import { spentOverPeriod } from '../bulk/matrix.js';
import { api } from '../shell/api.js';
import { useAsync } from '../shell/useAsync.js';

/**
 * What this one Experiment has cost.
 *
 * R194 asks for the same compact pair of numbers for an Experiment as for a Bulk Run
 * and for a period: what the work was estimated at, what the providers reported, and
 * how many Generation Attempts the two are made of. Nothing else - no balance, no
 * tokens, no invoice, and no per-Candidate breakdown that would turn a cost line into
 * a creative judgement.
 *
 * It says nothing at all until there is something to say: an Experiment that has not
 * generated anything yet has no spend, and a zero on the screen reads as a claim.
 */
export function ExperimentSpend({ experimentId }: { experimentId: string }): ReactNode {
  const costs = useAsync<CostSummaryResource>(() => api.readCosts({ experimentId }), [experimentId]);
  const summary = costs.value;
  if (summary === null || summary.attemptCount + summary.subscriptionAttemptCount === 0) return null;

  return <p className="note experiment-spend">{spentOverPeriod(summary)}</p>;
}
